/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";

export const GET_UTILITY_CENTERS = gql`
  query GetDistCents($options: GetManyOptions, $filter: DistCentFilterInput) {
    getDistCents(options: $options, filter: $filter) {
      count
      content {
        id
        name
        geoLocation {
          coordinates
          type
        }
        distCenterId
        description
        address
        noOfCounters
        updatedAt
        createdAt
        tokenIDChar
      }
      limit
      skip
    }

    getCompleteDistCents: getDistCents {
      count
      content {
        id
        name
        geoLocation {
          coordinates
          type
        }
        distCenterId
        description
        address
        noOfCounters
        updatedAt
        createdAt
        tokenIDChar
      }
      limit
      skip
    }
  }
`;
